<div class="mat-elevation-z2">
  <table
    mat-table
    class="full-width-table"
    matSort
    matSortActive="updatedAt"
    matSortDirection="desc"
    matSortDisableClear="true"
    aria-label="Elements">
    <!-- Id Column -->
    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>STATE</th>
      <td mat-cell *matCellDef="let row">{{ row.status }}</td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="packageVersion">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        FIRMWARE PACKAGE BUNDLE VERSION
      </th>
      <td mat-cell *matCellDef="let row">{{ row.packageVersion }}</td>
    </ng-container>

    <!-- Updated At Column -->
    <ng-container matColumnDef="updatedAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>UPDATED AT</th>
      <td mat-cell *matCellDef="let row">
        {{ row.updatedAt | formatDateTime }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row (click)="goToDetails(row)" *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    #paginator
    [length]="dataSource.data.length"
    [pageIndex]="0"
    [pageSize]="10"
    [pageSizeOptions]="[5, 10, 20]"
    aria-label="Select page">
  </mat-paginator>
</div>
